import React from "react";
import Chart from "react-apexcharts";
import CardComponent from "../../../components/CardComponent";

const SupplierBarChart = ({ rows, valueType }) => {
  const isEnergy = valueType === "Energy";

  const series = isEnergy
    ? [
      {
        name: "Energy Company",
        data: rows?.monthlyData?.map((item) => item?.Energy_company || 0),
      },
      {
        name: "Zones",
        data: rows?.monthlyData?.map((item) => item?.zones || 0),
      },
      {
        name: "Regional Offices",
        data: rows?.monthlyData?.map((item) => item?.regional_offices || 0),
      },
      {
        name: "Sales Areas",
        data: rows?.monthlyData?.map((item) => item?.sales_area || 0),
      },
      {
        name: "Districts",
        data: rows?.monthlyData?.map((item) => item?.districts || 0),
      },
    ]
    : [
      {
        name: "Requested",
        data: rows?.formattedData?.map(
          (item) => item?.[`Requested${valueType}`] || 0
        ),
      },
      {
        name: "Approved",
        data: rows?.formattedData?.map(
          (item) => item?.[`Approved${valueType}`] || 0
        ),
      },
      {
        name: "Rejected",
        data: rows?.formattedData?.map(
          (item) => item?.[`Rejected${valueType}`] || 0
        ),
      },
    ];

  const categories = isEnergy
    ? rows?.monthlyData?.map((item) => item?.month)
    : rows?.formattedData?.map((item) => item?.month);

  const chartData = {
    series,
    options: {
      chart: {
        type: "bar",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          borderRadius: 2,
          horizontal: false,
          columnWidth: "65%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        markers: { radius: 12 },
      },
      stroke: {
        show: true,
        width: 10,
        colors: ["transparent"],
      },
      xaxis: {
        categories,
      },
      grid: {
        borderColor: "#EFF1F3",
      },
      colors: isEnergy
        ? ["#5200ff", "#09bd94", "#f16a1b", "#00bcd4", "#f44336"]
        : ["#F39C12", "#27AE60", "#E74C3C"],
    },
  };

  return (
    <CardComponent showCardHeader={true} title="Bar Chart Analysis">
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={300}
      />
    </CardComponent>
  );
};

export default SupplierBarChart;
